import React from 'react';
import { IconPhoto, useTheme } from '@veneer/core';

import { DeviceImageWrapper, ImagePlaceholder } from '../styled';

export type DeviceImageCellProps = {
  imageUrl?: string | null;
  imageAlt: string;
  placeholderAriaLabel: string;
};

const DeviceImageCell: React.FC<DeviceImageCellProps> = ({
  imageUrl,
  imageAlt,
  placeholderAriaLabel
}) => {
  const theme = useTheme();

  return (
    <DeviceImageWrapper>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={imageAlt}
          width={110}
          height={63}
          style={{ objectFit: 'contain' }}
        />
      ) : (
        <ImagePlaceholder
          $veneerTheme={theme}
          aria-label={placeholderAriaLabel}
        >
          <IconPhoto
            color="white"
            size={36}
            aria-hidden
          />
        </ImagePlaceholder>
      )}
    </DeviceImageWrapper>
  );
};

export default DeviceImageCell;
